import React from 'react';
import { motion } from 'motion/react';
import { Mail, Shield } from 'lucide-react';
import { contactData } from '../../data/mock';

const Footer = () => {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="relative py-12 mt-16"
    >
      {/* Subtle gradient divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-[#CBC9CF] to-transparent" />
      
      <div className="max-w-4xl mx-auto px-6 text-center">
        {/* Contact info */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 mb-8">
          <motion.a
            href={`mailto:${contactData.email}`}
            whileHover={{ scale: 1.02 }}
            className="flex items-center gap-2 text-[#3C3B3D] hover:text-[#008055] transition-colors"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            <Mail className="w-4 h-4" />
            <span>{contactData.email}</span>
          </motion.a>
          
          <motion.a
            href={`mailto:${contactData.privacyEmail}`}
            whileHover={{ scale: 1.02 }}
            className="flex items-center gap-2 text-[#3C3B3D] hover:text-[#008055] transition-colors"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            <Shield className="w-4 h-4" />
            <span>{contactData.privacyEmail}</span>
          </motion.a>
        </div>
        
        {/* Copyright */}
        <p
          className="text-sm text-[#757478]"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          © {new Date().getFullYear()} POSTAÍ. Todos os direitos reservados.
        </p>
      </div>
    </motion.footer>
  );
};

export default Footer;
